/**
 * handleItemsReceived.js
 *
 * Copyright (c) apploft. GmbH
 */

import {presentingList} from '../ContentStateSymbol';

export default function handleItemsReceived({items, section, api}) {
  items.sort((a, b) => {
    return new Date(a.submission) > new Date(b.submission) ? -1 : 1;
  });

  return {state: presentingList, data: {items, section, api}};
}
